import { INTX_TYPES } from "../../../constants/intxConstants";
import { AREA_TYPES } from "../../../constants/geographyConstants";
import { SafetyFacilityType } from "../../../calculations/safety/SPFConstants";

export const NO_INFO_NEEDED_MESSAGE = "No further information needed";

export const FACILITY_TYPE_TO_AREA_TYPE = {
  [SafetyFacilityType.RURAL_MULTILANE_HIGHWAY]: AREA_TYPES.RURAL,
  [SafetyFacilityType.TWO_LANE_RURAL_ROADWAY]: AREA_TYPES.RURAL,
  [SafetyFacilityType.URBAN_SUBURBAN_ARTERIAL]: AREA_TYPES.URBAN,
  [SafetyFacilityType.URBAN_SUBURBAN_COLLECTOR]: AREA_TYPES.URBAN,
};

/**
 * intersections whose CMFs follow the same relatively simple pattern of having one default value and values for rural/urbal TWSC
 */
export const BASIC_CMF_INTERSECTIONS = [
  INTX_TYPES.DLT,
  INTX_TYPES.MUT,
  INTX_TYPES.RCUT_SIGNALIZED,
  INTX_TYPES.RCUT_UNSIGNALIZED,
  INTX_TYPES.CGT,
  INTX_TYPES.JUGHANDLE,
];

/**
 * intersections that always use CMFs but have their own special logic for which CMF to use
 */
export const COMPLEX_CMF_INTERSECTIONS = [
  INTX_TYPES.TWO_LANE_ROUNDABOUT,
  INTX_TYPES.DDI,
  INTX_TYPES.DIAMOND_WITH_TWO_LANE_ROUNDABOUTS,
];

/**
 * intersections that ask the user to enter a CMF and base SPF to apply to
 */
export const USER_ENTERED_CMF_INTX_TYPES = [
  INTX_TYPES.QUADRANT_ROADWAY,
  INTX_TYPES.OTHER,
  INTX_TYPES.SINGLE_POINT_DIAMOND,
];

/**
 * intersections who always use SPFs no matter what
 */
export const SPF_INTERSECTIONS = [
  INTX_TYPES.TWSC,
  INTX_TYPES.DIAMOND_WITH_SIGNALS,
  INTX_TYPES.DIAMOND_WITH_STOP_CONTROL,
];

export const SAFETY_INPUT_TYPES = {
  CMF: "CMF",
  CMF_USER_ENTERED: "CMF_USER_ENTERED",
  SPF: "SPF",
};

export const SPF_FIELD_NAMES = {
  MAJOR_ROAD_HAS_CROSSWALK: "majorRoadHasCrosswalk",
  MINOR_ROAD_HAS_CROSSWALK: "minorRoadHasCrosswalk",
  MAJOR_HAS_EXCLUSIVE_LEFT: "majorHasExclusiveLeft",
  MINOR_HAS_EXCLUSIVE_LEFT: "minorHasExclusiveLeft",
  MAJOR_HAS_EXCLUSIVE_RIGHT: "hasExclusiveRight",
  MINOR_HAS_EXCLUSIVE_RIGHT: "minorHasExclusiveRight",
  MAJOR_ROAD_SPEED_LIMIT: "majorRoadSpeedLimit",
  MINOR_ROAD_SPEED_LIMIT: "minorRoadSpeedLimit",
  SKEW_ANGLE: "skewAngle",
};

export const SPF_FIELDS = {
  MAJOR_ROAD_HAS_CROSSWALK: {
    label: "Major road crosswalk",
    name: SPF_FIELD_NAMES.MAJOR_ROAD_HAS_CROSSWALK,
  },
  MINOR_ROAD_HAS_CROSSWALK: {
    label: "Minor road crosswalk",
    name: SPF_FIELD_NAMES.MINOR_ROAD_HAS_CROSSWALK,
  },
  MAJOR_HAS_EXCLUSIVE_LEFT: {
    label: "Major road exclusive left turn lane",
    name: SPF_FIELD_NAMES.MAJOR_HAS_EXCLUSIVE_LEFT,
  },
  MINOR_HAS_EXCLUSIVE_LEFT: {
    label: "Minor road exclusive left turn lane",
    name: SPF_FIELD_NAMES.MINOR_HAS_EXCLUSIVE_LEFT,
  },
  MAJOR_HAS_EXCLUSIVE_RIGHT: {
    label: "Major road exclusive right turn lane",
    name: SPF_FIELD_NAMES.MAJOR_HAS_EXCLUSIVE_RIGHT,
  },
  MINOR_HAS_EXCLUSIVE_RIGHT: {
    label: "Minor road exclusive right turn lane",
    name: SPF_FIELD_NAMES.MINOR_HAS_EXCLUSIVE_RIGHT,
  },
  MAJOR_ROAD_SPEED_LIMIT: {
    label: "Major Road Speed Limit",
    name: SPF_FIELD_NAMES.MAJOR_ROAD_SPEED_LIMIT,
  },
  MINOR_ROAD_SPEED_LIMIT: {
    label: "Minor Road Speed Limit",
    name: SPF_FIELD_NAMES.MINOR_ROAD_SPEED_LIMIT,
  },
  SKEW_ANGLE: {
    label: "Skew Angle",
    name: SPF_FIELD_NAMES.SKEW_ANGLE,
  },
};
